import PageMeta from "../components/PageMeta";
import { RequestButton, ContactCTA } from "../components/SiteShell";
import ServiceAccordion from "../components/ServiceAccordion";
export default function Services() {
  return (
    <>
      <PageMeta
        title="Owners corporation services | Owners First"
        description="Maintenance, financials, insurance, meetings and regular property visits. Explore our owners corporation management services in Melbourne."
      />
      <section className="site-wrap site-page-intro site-services-intro">
        <h1>
          Consider
          <br />
          <span>it handled.</span>
        </h1>
        <div>
          <p>
            Buildings need care. Owners need clarity. We bring the two together,
            with practical support for every part of your owners corporation.
          </p>
          <RequestButton />
        </div>
      </section>
      <div className="site-wrap site-wide-image">
        <img
          src="/images/interior.jpg"
          alt="A carefully maintained contemporary apartment entrance and shared lobby"
          fetchpriority="high"
          width="1792"
          height="1024"
        />
      </div>
      <section className="site-wrap site-section site-services-layout">
        <div className="site-section-intro">
          <h2>
            Support that
            <br />
            covers the detail.
          </h2>
          <p>
            From an everyday repair to a decision about the building’s future,
            you have a team to call on.
          </p>
        </div>
        <ServiceAccordion full />
      </section>
      <section className="site-surface site-section">
        <div className="site-wrap site-service-promise">
          <h2>
            We know the building.
            <br />
            <span>We know what matters.</span>
          </h2>
          <p>
            Our managers visit at least four times a year. That first-hand
            knowledge informs the advice we give, the contractors we coordinate
            and the way we respond when something needs attention.
          </p>
        </div>
      </section>
      <ContactCTA />
    </>
  );
}
